import { getChosenLocale, loadTranslations } from '#pplx/frontend/i18n/browser.js';
import { DEFAULT_LOCALE } from '#pplx_generated/pplx/frontend/i18n/localeInfo.generated.js';
import { memoize } from 'lodash-es';
/** Shared by `ClientTranslationsProvider` and early preloads so both await the same load. */
export const memoizedLoadTranslations = memoize(loadTranslations, (locale, localeTranslations) => `${locale}:${localeTranslations ? 'custom' : 'default'}`);
/**
 * Starts loading the chosen locale's messages before `ClientTranslationsProvider` mounts. The
 * provider suspends its whole subtree on that load, so starting it from an entry module lets it
 * download alongside the app's route chunks instead of after them.
 */
export function preloadClientTranslations(localeTranslations) {
    const locale = getChosenLocale();
    if (locale === DEFAULT_LOCALE)
        return;
    void memoizedLoadTranslations(locale, localeTranslations);
}
//# sourceMappingURL=clientTranslations.js.map